export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 110,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_fileName') || '文件名称',
    field: 'fileName',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_fileSize') || '文件大小',
    field: 'fileSize',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_orderFileType') || '订单文件类型',
    field: 'v_orderFileType',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_remark') || '备注说明',
    field: 'remark',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_creator') || '创建人',
    field: 'createByName',
    minWidth: 170,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'createInfo' },
  },
  {
    title: that.$l('table_label_modified_by') || '修改人',
    field: 'modifyByName',
    minWidth: 170,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'modifyInfo' },
  },
]
